module.exports = __webpack_public_path__ + "static/media/error-animation.10929841.gif";